import React from 'react'
import ReactSlider from 'react-slider'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface RiskSliderProps {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
  label: string
  tooltipText: string
}

const RiskSlider: React.FC<RiskSliderProps> = ({
  value,
  onChange,
  disabled = false,
  label,
  tooltipText,
}) => {
  return (
    <div className='mb-4'>
      <h6 className='fw-semibold mb-3'>
        {label}{' '}
        <OverlayTrigger
          placement='right'
          overlay={
            <Tooltip id={`tooltip-${label.toLowerCase()}`}>
              <span>{tooltipText}</span>
            </Tooltip>
          }
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#5A5A5A'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-info-circle ms-1'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
            <path d='M12 9h.01' />
            <path d='M11 12h1v4h1' />
          </svg>
        </OverlayTrigger>
      </h6>
      <div style={{padding: '10px 0 10px'}}>
        <ReactSlider
          className='mx-0'
          disabled={disabled}
          marks
          min={1}
          max={5}
          step={1}
          value={value}
          onChange={onChange}
          renderTrack={(props, state) => {
            const {index} = state
            return (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '6px',
                  top: '0',
                  background: index === 0 ? '#20c997' : '#e9ecef',
                  borderRadius: '3px',
                }}
              />
            )
          }}
          renderThumb={(props) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '20px',
                width: '20px',
                backgroundColor: 'white',
                border: '2px solid #20c997',
                borderRadius: '50%',
                cursor: 'grab',
                top: '-8px',
                zIndex: 0,
              }}
            />
          )}
          renderMark={(props) => (
            <div
              {...props}
              style={{
                ...props.style,
                width: '4px',
                height: '12px',
                backgroundColor: '#F6F6F6',
                top: '14px',
              }}
            />
          )}
        />
      </div>
      <div className='d-flex justify-content-between mx-3'>
        {[1, 2, 3, 4, 5].map((num) => (
          <span key={num} className='text-bold' style={{fontSize: '12px'}}>
            {num}
          </span>
        ))}
      </div>
    </div>
  )
}

export default RiskSlider 